import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::scan
* @see app/Http/Controllers/Api/V1/MiniAppController.php:99
* @route '/api/v1/mini-app/qr/scan'
*/
export const scan = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: scan.url(options),
    method: 'post',
})

scan.definition = {
    methods: ["post"],
    url: '/api/v1/mini-app/qr/scan',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::scan
* @see app/Http/Controllers/Api/V1/MiniAppController.php:99
* @route '/api/v1/mini-app/qr/scan'
*/
scan.url = (options?: RouteQueryOptions) => {
    return scan.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::scan
* @see app/Http/Controllers/Api/V1/MiniAppController.php:99
* @route '/api/v1/mini-app/qr/scan'
*/
scan.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: scan.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::scan
* @see app/Http/Controllers/Api/V1/MiniAppController.php:99
* @route '/api/v1/mini-app/qr/scan'
*/
const scanForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: scan.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::scan
* @see app/Http/Controllers/Api/V1/MiniAppController.php:99
* @route '/api/v1/mini-app/qr/scan'
*/
scanForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: scan.url(options),
    method: 'post',
})

scan.form = scanForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::discard
* @see app/Http/Controllers/Api/V1/MiniAppController.php:109
* @route '/api/v1/mini-app/qr/scan'
*/
export const discard = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: discard.url(options),
    method: 'delete',
})

discard.definition = {
    methods: ["delete"],
    url: '/api/v1/mini-app/qr/scan',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::discard
* @see app/Http/Controllers/Api/V1/MiniAppController.php:109
* @route '/api/v1/mini-app/qr/scan'
*/
discard.url = (options?: RouteQueryOptions) => {
    return discard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::discard
* @see app/Http/Controllers/Api/V1/MiniAppController.php:109
* @route '/api/v1/mini-app/qr/scan'
*/
discard.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: discard.url(options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::discard
* @see app/Http/Controllers/Api/V1/MiniAppController.php:109
* @route '/api/v1/mini-app/qr/scan'
*/
const discardForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: discard.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppController::discard
* @see app/Http/Controllers/Api/V1/MiniAppController.php:109
* @route '/api/v1/mini-app/qr/scan'
*/
discardForm.delete = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: discard.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

discard.form = discardForm

const qr = {
    scan: Object.assign(scan, scan),
    discard: Object.assign(discard, discard),
}

export default qr